import MainLayout from "@/components/layout/admin/MainLayout.vue";
export default {
    name: "JobDeletedJob",
    components: {
        MainLayout
    }
};